import React from 'react';
import {
    Link,
} from "react-router-dom";

import ServerApi from '../../services/server-api-service';
import CookiesManager from '../../services/cookies-manager';
import FormCheckService from '../../services/form-check-service';
import ConfigurationService from '../../services/configuration-service';
import Select, { components, GroupProps } from 'react-select';
import ThanksModal from '../thanks-modal';


import './user-form-style.css';
const telephones = require('./tel.json');
const FLAGBAN = "US";

class UserForm extends React.Component {
    serverApi = new ServerApi();
    cookiesManager = null;
    formCheckService = new FormCheckService();
    configurationService = new ConfigurationService();
    constructor(props) {
        super(props);
        this.state = {
            debug: false,
            isVisibleThanksModal: false,
            isDefaultText:true,
            contactForm: {
                userFullName: '',
                userPhone: '',
                userEmail: '',
                userComment: ''
            },
            currentNumber: null,
            currentElement: null,
            telephonesList: telephones
        }
        this.lang = this.configurationService.getCurrentLanguagePrefix();
    }

    componentDidMount() {
        let {countryCodeSelector = false, country } = this.props;
        this.cookiesManager = new CookiesManager();
       
        this.setState({
            initialForm: this.props.contactForm
        })

        if(country != null && countryCodeSelector){ 
            this.saveElement(telephones.find(el=> el.code === country));
        }
    }

    componentWillMount() {
        // this.serverApi.getTelephoneList()
        // .then((data) => {
        //     this.setState({
        //             telephonesList: data
        //     })
        // })
        // .catch((error) => {
        //     console.log(`ERROR: fetch getTelephoneList ... -> Component: user form ERROR:${error}`);
           
        // })
    }



    componentDidUpdate(prevProps) {
        // if (prevProps.selectedCountry !== this.props.selectedCountry) {
        //   this.saveElement(this.props.selectedCountry);
        // }
    }

    handleInput = (event) => {
        if (this.props.handleInput) this.props.handleInput(event);
        if(event.target.name == 'userComment'){
            if(event.target.value != this.state.initialForm.userComment){
                this.setState({isDefaultText: false});
            }else{
                this.setState({isDefaultText: true});
            }
           
        }
        // this.setState({
        //     contactForm: {
        //         ...this.state.contactForm,
        //         [event.target.name]: event.target.value
        //     }
        // })
    }


    handleSubmit = (event) => {
        let {currentNumber} = this.state;
        let {inputBans = { comment: false, message: false, email: false, phone: false},closeModal, contactForm, clearForm, openThanksModal,thankModal, handleSubmit } = this.props;
        event.preventDefault();

        //if(this.props.handleSubmit) this.props.handleSubmit(this.state.currentElement.dial_code);
        if (handleSubmit) handleSubmit();
        else if (!this.formCheckService.checkContactForm(contactForm, inputBans )) {
            let form = Object.assign({}, contactForm);
            form.isDefaultText = this.state.isDefaultText;
            //if(this.state.currentElement.code!==FLAGBAN)
            //form.userPhone=this.state.currentElement.dial_code+this.props.contactForm.userPhone;
            if (this.state.debug) {
                console.log(form)
            }

            if(currentNumber != null &&  contactForm.userPhone != ''){
                form.userPhone = currentNumber + contactForm.userPhone;
            }

            this.serverApi.sendForm(form)
                .then((data) => {
                    this.cookiesManager.set('exit_pop', '1', 365)
                    if (this.state.debug) {
                        console.log(data);
                    }
                    if (clearForm) clearForm();
                    if (openThanksModal) openThanksModal();
                    else if (thankModal) this.openDefaultModal();
                    else if (closeModal) closeModal();
                })
                .catch((error) => {
                    console.log(`ERROR: fetch sendForm ... -> Component: join team modal ERROR:${error}`);
                })
        }
    }

    handleChange = (event) => {
        if (this.state.debug) console.log(event);
        this.setState({
            currentNumber: event.dial_code,
            currentElement: event
        })
        if (this.props.saveCurrentSelectedCountry) this.props.saveCurrentSelectedCountry(event);

    }

    openDefaultModal = () => {
        this.setState((prevState) => {
            return {
                ...prevState,
                isVisibleThanksModal: !prevState.isVisibleThanksModal
            }
        })
    }

    CustomOption(props) {
        let { children, isDisabled, innerProps } = props;
        if (!isDisabled) {
            return (<div className="CustomOption" {...innerProps}><img className="Image" loading="lazy"  src={` https://flagsapi.com/${props.code}/flat/64.png`} />	{props.name}&nbsp;{props.dial_code} </div>)
        } else return (null)
    }

    saveNumber(number) {
        this.setState({
            currentNumber: number
        })
    }

    saveElement(elem) {
        this.setState({
            currentElement: elem,
            currentNumber: elem.dial_code
        })
    }

    renderPhoneInput() {
        let { width, countryCodeSelector = false, className, style, dictionary, country, selectedCountry = null, CustomInputStyle = { padding: '0 0 0 5px' },customLandingForm = false } = this.props;
        let { currentElement, telephonesList } = this.state;
        let elem;

        if(currentElement === null && Array.isArray(telephonesList)){
            if(selectedCountry != null) this.saveElement(selectedCountry);
            else if(country != null && countryCodeSelector){ 
                this.saveElement(telephonesList.find(el=> el.code === country));
            }
        }
        let inputClassName = 'Input'
        if(customLandingForm) inputClassName = ''
      
        // if(currentElement !== null && currentElement.code === FLAGBAN){
        if(currentElement == null || !countryCodeSelector ){
        // if (1 == 1) {
            return (<input
                onChange={this.handleInput}
                name='userPhone'
                className={inputClassName}
                placeholder={dictionary.phone}
                type="text"
                value={this.props.contactForm.userPhone}></input>)
        }
        else
            if (currentElement !== null && telephonesList !== undefined && countryCodeSelector) {
                return (
                    <div className="Input CustomInput" style={CustomInputStyle} tabindex="-1">
                        <Select
                            tabIndex={-1}
                            value={currentElement}
                            //components={{Option:this.CustomOption,ValueOption:this.ValueOption}}
                            formatOptionLabel={this.CustomOption}
                            isSearchable={false}
                            options={telephonesList}
                            onChange={this.handleChange}
                            styles={{
                                control: (provided, state) => ({
                                    ...provided,
                                    border: "none",
                                    backgroundColor: 'inherit',
                                    maxHeight: '28px',
                                    minHeight: '0',
                                    maxWidth: '70px',
                                    justifyContent: 'left',
                                }),
                                menu: (provided, state) => ({
                                    ...provided,
                                    width: '300px'
                                }),
                                indicatorSeparator: (provided, state) => ({
                                    ...provided,
                                    display: 'none'
                                }),
                                valueContainer: (provided, state) => ({
                                    ...provided,
                                    marginBottom: '6px',
                                    padding: '2px 0 2px 1px',
                                    maxWidth: '28px'
                                }),
                                indicatorsContainer: (provided, state) => ({
                                    ...provided,
                                    '.css-1gtu0rj-indicatorContainer': {
                                        padding: '8px 0 8px 0'
                                    },
                                    '.css-tlfecz-indicatorContainer': {
                                        padding: '8px 0 8px 0'
                                    }

                                }),
                                singleValue: (provided, state) => ({
                                    ...provided,
                                    width: '20px'
                                }),
                            }}
                            name="location"
                            className="Select"
                        />
                        <div className="CountryNumber">
                            {currentElement.dial_code}
                        </div>
                       <input
                onChange={this.handleInput}
                name='userPhone'
                className={inputClassName}
                placeholder={dictionary.phone}
                type="text"
                value={this.props.contactForm.userPhone}></input>
                    </div>
                )
            } else return null;

    }

    renderFormBody() {
        let { width, className, disableMessage = false, urgencyMessage = null, style, dictionary, watcher,
            secureInfo = false, buttonTitle = dictionary.submit, topPartRow = false,
            inputBans = { comment: false, message: false, email: false}, message = dictionary.thank_you,
            newButtons = false, customLandingForm = false,formTitle ='' } = this.props;

        const iconLock = require('../../elements/icons/s_secured.png');

        
        let privacy_link = '/privacy';
      
        const subdomain = this.configurationService.getSubdomain();
        if(subdomain){
            if(this.lang =='en') privacy_link = (this.configurationService.getCurrentSite()).replace(subdomain+'.',"")+"privacy";
            else  privacy_link = this.configurationService.getCurrentSite().replace(subdomain,this.lang)+"privacy";;
        }

        if (customLandingForm) {
            return (
                <>
                    <div className={"contactForm"}>
                        <div className={"contactFormHeader"}>{formTitle}</div>
                        <input onChange={this.handleInput} name='userFullName' placeholder={`Your name`} type="text" value={this.props.contactForm.userFullName}></input>
                        {this.renderPhoneInput()}
                        <input onChange={this.handleInput} name='userEmail' placeholder={`Your email`} type="text" value={this.props.contactForm.userEmail}></input>
                        <textarea onChange={this.handleInput} name='userComment' placeholder={dictionary.message} type="text" value={this.props.contactForm.userComment}></textarea>
                        <button onClick={this.handleSubmit} className={"requestButton"}>{'Request a consultation'}</button>
                        {/* <div className={"contactFormHeader"}></div>
                        <input type={"text"} placeholder={"Your name"}></input>
                        <input type={"text"} placeholder={"Your phone number"}></input>
                        <input type={"text"} placeholder={"Your email"}></input>
                        <textarea></textarea>
                        <div className={"requestButton"}>Request a consultation</div> */}
                    </div>
                </>
            )
        } else {
            return (
                <>
                    <form className={`JoinTeamForm ${className}`}
                        onFocus={() => { if (watcher) watcher.stopWatcher() }}
                        onBlur={() => { if (watcher) watcher.resumeWatcher() }}
                        style={style}>
                        <div>
                            {/* <div className={topPartRow ? ('TopPartForm') : null}>
                                
                            </div> */}
                            <input onChange={this.handleInput} name='userFullName' className="Input" placeholder={dictionary.full_name} type="text" value={this.props.contactForm.userFullName}></input>
                            {/* <input onChange={this.handleInput} name='userPhone' className="Input" placeholder={dictionary.phone} type="text" value={this.props.contactForm.userPhone}></input> */}
                            {inputBans.phone ? null : this.renderPhoneInput()}
                            {inputBans.email ? null : <input onChange={this.handleInput} name='userEmail' className="Input" placeholder={dictionary.email} type="text" value={this.props.contactForm.userEmail}></input>}
                            {(!inputBans.comment && urgencyMessage == null) && (!disableMessage) ? <textarea onChange={this.handleInput} name='userComment' className="Input" placeholder={dictionary.message} type="text" value={this.props.contactForm.userComment}></textarea> : (null)}
                            {secureInfo ? (
                                <div className="SecureDiv ListingPageSecureBlock">
                                    <img className="SecureIcon" src={iconLock} alt="" />
                                    <span className="Text">
                                        {dictionary.information_secure}
                                        <Link style={{whiteSpace:'nowrap'}} target="_blank" to={{pathname: privacy_link}}> {dictionary.privacy_policy_lower ?? dictionary.privacy_policy}</Link>
                                       
                                    </span>
                                </div>
                            ) : (null)}
                            <button onClick={this.handleSubmit} id={newButtons ? `ButtonLight` : null} className={`Button`}>{urgencyMessage ? (dictionary.request_about) : (buttonTitle)}</button>
                        </div>
                    </form>
                </>
            )
        }

    }

    render() {
        let {dictionary, message = dictionary.thank_you, closeModal = undefined , inputBans} = this.props;

        return (
            <>
                {this.renderFormBody()}
                 <ThanksModal
                        isVisible={this.state.isVisibleThanksModal}
                        title={dictionary.thank_you}
                        message={message}
                        closeModal={closeModal ? closeModal :  this.openDefaultModal}
                />
                
            </>
        )
    };
}

export default UserForm;